module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "futurebet-container"
  }, [_c('div', {
    staticClass: "futurebet-info"
  }, [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate",
      value: ('future_bet'),
      expression: "'future_bet'"
    }],
    staticClass: "futurebet-label"
  })]), _vm._v(" "), _c('div', {
    staticClass: "futurebet-boxes"
  }, _vm._l((_vm.maxFutureRounds), function(n) {
    return _c('div', {
      key: n,
      staticClass: "futurebet-box",
      class: {
        is__active: n == _vm.bettingSvc.numEvents
      },
      on: {
        "click": function($event) {
          _vm.setFutureRound(n)
        }
      }
    }, [_c('div', {
      staticClass: "futurebet-number"
    }, [_vm._v(" \n            " + _vm._s(n) + " \n         ")])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee4435cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FutureBets.vue
// module id = 411
// module chunks = 0